import { render, staticRenderFns } from "./PaymentRequest.vue?vue&type=template&id=51f6af74&"
import script from "./PaymentRequest.vue?vue&type=script&lang=js&"
export * from "./PaymentRequest.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequest.vue?vue&type=style&index=0&id=51f6af74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports